export const SITE_CONFIG = {
  phone: "02 6292 1092",
  address: "Unit 4, 2 Hanlon Cres, Fadden ACT 2904",
  bookingUrl: "https://cbrhealthcare.bookings.pracsuite.com/guest",
  logo: "https://d1zviajkun9gxg.cloudfront.net/user/prod/2023/05/03/deal-154f3ed8-3d1e-4609-821a-676a6fc7fb2c.png",
  chiropracticBrand: "Tuggeranong Chiropractic Centre",
  massageBrand: "Tuggeranong Therapeutic Massage",
  anniversary: "Serving Canberra since 1976",
  pricingNote: "Effective 1 July 2026. In-clinic services are priced as shown below.",
  cancellationPolicy: "Full price fees may apply if less than 24 hours notice is given to cancel or reschedule appointments. There will be no fee charged for those cancelling due to illness or reasonable/exceptional circumstances.",
  nearbySuburbs: [
    "Fadden", "Gowrie", "Macarthur", "Chisholm", "Wanniassa", "Monash", "Gilmore", "Richardson", "Isabella Plains", "Oxley", "Greenway", "Kambah", "Calwell"
  ]
};

export const homeContent = {
  hero: {
    title: "Support your recovery and regain movement confidence",
    subtitle: "Tuggeranong Chiropractic Centre",
    anniversaryTag: "Serving Canberra since 1976",
    description1: "Before you consider more invasive options, visit us for a comprehensive clinical assessment.",
    description2: "Looking for long-term management strategies? Our experienced team is here to help.",
    image: "https://d1zviajkun9gxg.cloudfront.net/user/prod/2023/08/01/deal-a398ab23-3a22-44e6-ba4c-9678a6efc602.jpeg",
    points: [
      "Evidence-based management plans",
      "Improve your functional movement",
      "Guided rehab and exercise strategies",
      "Clinical assessment and diagnosis",
      "Practitioners with 15+ years experience"
    ]
  },
  anniversary: {
    title: "Serving Canberra since 1976",
    subtitle: "A half-century milestone",
    description: "Since 1976, we have been dedicated to providing evidence-based allied health care to the Canberra community. Our legacy is built on patient trust and a commitment to professional clinical standards.",
    stats: [
      { label: "Years in practice", value: "50" },
      { label: "Patients served", value: "38k+" },
      { label: "Community trust", value: "Established" }
    ]
  },
  whyVisit: {
    title: "Our clinical approach",
    description: "We focus on understanding your specific clinical picture. We dedicate time in your first visit to perform a thorough assessment and discuss your management goals.",
    image: "https://d1zviajkun9gxg.cloudfront.net/user/prod/2023/08/24/deal-2f7bc306-1f96-41d1-9e1e-a56d249e16f9.jpeg",
    features: [
      { 
        title: "Comprehensive assessment", 
        text: "A thorough initial consultation to create a detailed clinical profile of your condition."
      },
      { 
        title: "Highly experienced team", 
        text: "Our chiropractors and massage therapists each have over 15 years of clinical experience."
      },
      { 
        title: "Evidence-based care", 
        text: "We utilise non-surgical and non-medicinal strategies focused on restoring function and mobility."
      }
    ]
  },
  team: [
    { 
      slug: "louise-hughes",
      name: "Dr Louise Hughes", 
      role: "Chiropractor", 
      qualifications: "B.ChiroSc; M.Chiro; Doctor of Chiropractic",
      specialities: ["Chiropractic", "Dry needling"],
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:800/h:1000/q:mauto/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2026/04/LouiseHughes-1.jpg",
      bio: [
        "Dr Louise Hughes is a chiropractor with a strong passion for biomechanics, rehabilitation and evidence-based musculoskeletal care. Growing up on Sydney’s Northern Beaches, Louise developed an early interest in physics, mathematics and engineering, which ultimately led her toward chiropractic as a career that combined science, movement and helping people.",
        "After completing her Bachelor of Chiropractic Science and Master of Chiropractic at Macquarie University, Louise went on to work in a range of settings across Australia and overseas. These experiences helped shape her practical, grounded approach to care and gave her a clear sense of the kind of chiropractor she wanted to be.",
        "Louise’s approach is biomechanical and individualised, with an emphasis on manual adjusting, soft tissue work and rehabilitation. She has a particular interest in movement quality, gym and weight lifting biomechanics, and helping patients return to the activities that matter to them.",
        "Louise enjoys working with patients from a wide range of backgrounds and strives to provide clear, personalised care that is informed by the best available evidence. Her goal is to help patients move better, feel better and build confidence in their bodies.",
        "Outside the clinic, Louise enjoys CrossFit, gardening, camping, target shooting and gun dog training."
      ]
    },
    { 
      slug: "nash-anderson",
      name: "Dr Nash Anderson", 
      role: "Chiropractor", 
      qualifications: "B.Sc; M.Chiro; ICCSP; Doctor of Chiropractic",
      specialities: ["Sports Chiropractic", "Exercise Medicine", "Clinical Research", "Peer Review"],
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:800/h:1000/q:mauto/dpr:1.5/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2022/10/IMG_20190219_084323.jpg",
      bio: [
        "Dr Nash Anderson, a seasoned chiropractor, is a valued member of our team at Tuggeranong Chiropractic Centre. His journey to chiropractic care began right here, in this clinic, as a child. After experiencing musculoskeletal discomfort from sports-related injuries, Nash discovered the benefits of chiropractic firsthand. This inspired his career in chiropractic, where he combines a passion for helping active individuals with a strong commitment to caring for the whole community.",
        "Today, Nash brings extensive experience in musculoskeletal health, exercise medicine, and rehabilitation. While he has a special interest in sports chiropractic and research, he also enjoys supporting families, veterans, children, pregnant women, and older adults. His evidence-based approach ensures that every patient receives safe and effective care tailored to their individual needs.",
        "Beyond the clinic, Nash is actively engaged in research and has published in world-leading journals such as the British Journal of Sports Medicine. He served as a Senior Associate Editor for the British Medical Journal’s Open Access Sport and Exercise Medicine Journal for nearly a decade (2017–2026) and continues to contribute to the field by performing invited peer reviews for various medical journals. His work spans topics from the benefits of physical activity to health equity and the role of new technologies like AI in medicine.",
        "Whether you are a professional athlete, a parent, a veteran, an expectant mother, or someone managing chronic musculoskeletal conditions, Nash utilises his skills and experience to help you. His mission is to provide personalised, compassionate care, grounded in the latest research, to meet your unique health needs."
      ],
      achievements: [
        "Recent ACT Chair Sports Medicine Australia",
        "Senior Associate Editor British Medical Journal’s Open Sport and Exercise Medicine (2017–2026)",
        "Invited Peer Reviewer for leading medical and sports science journals",
        "Speaker at Sports Medicine Australia Symposium: 'Technology and its role in promoting safe and effective exercise'"
      ],
      researchInterests: [
        "Sports and exercise medicine", "Musculoskeletal health", "Sports injuries", "Rehabilitation", "Physical examination", "Evidence-based healthcare", "Research methodology", "Artificial intelligence in medical research", "Digital health and health communication"
      ],
      researchStats: {
        publications: 16,
        reads: "3,500+",
        citations: "400+",
        coAuthors: 50
      },
      publications: [
        {
          year: "2025",
          items: [
            {
              title: "Exercise for chronic musculoskeletal pain: time to prescribe with precision",
              journal: "BMJ Open Sport & Exercise Medicine, November 2025",
              authors: "Nitin Kumar Arora, Lars Donath, Clint T Miller, Nash Anderson, Daniel Belavy, et al.",
              link: "https://www.researchgate.net/publication/398066740_Exercise_for_chronic_musculoskeletal_pain_time_to_prescribe_with_precision"
            },
            {
              title: "Reporting guideline for the use of Generative Artificial Intelligence tools in MEdical Research: the GAMER Statement",
              journal: "BMJ Evidence-Based Medicine, May 2025",
              authors: "Xufei Luo, Yih Chung Tham, Mauro Giuffrè, Nash Anderson, Qing-Xin Yu, et al.",
              description: "A reporting guideline developed to improve transparency and consistency when generative artificial intelligence tools are used in medical research.",
              link: "https://www.researchgate.net/publication/391744130_Reporting_guideline_for_the_use_of_Generative_Artificial_intelligence_tools_in_MEdical_Research_the_GAMER_Statement"
            }
          ]
        },
        {
          year: "2024",
          items: [
            {
              title: "As a journal we have one voice: the editorial",
              journal: "BMJ Open Sport & Exercise Medicine, October 2024",
              authors: "Evert Verhagen, Daniel Ludovic Belavy, Amy Elizabeth Harwood, Nash Anderson, et al.",
              link: "https://www.researchgate.net/publication/384657328_As_a_journal_we_have_one_voice_the_editorial"
            },
            {
              title: "Ways to improve the methodology of meta-analysis in sports and exercise medicine: what do we often see in peer review?",
              journal: "BMJ Open Sport & Exercise Medicine, September 2024",
              authors: "Patrick J Owen, Ishtiaq Ahmed, Aamir Raoof Memon, Nash Anderson, Daniel Belavy, et al.",
              link: "https://www.researchgate.net/publication/384441329_Ways_to_improve_the_methodology_of_meta-analysis_in_sports_and_exercise_medicine_what_do_we_often_see_in_peer_review"
            },
            {
              title: "Common issues of systematic reviews in the sports and exercise medicine field",
              journal: "BMJ Open Sport & Exercise Medicine, January 2024",
              authors: "Aamir Raoof Memon, Patrick J Owen, Nash Anderson, Daniel Belavy, et al.",
              link: "https://www.researchgate.net/publication/377551430_Common_issues_of_systematic reviews_in_the_sports_and_exercise_medicine_field"
            }
          ]
        },
        {
          year: "2023",
          items: [
            {
              title: "Under-representation of women is alive and well in sport and exercise medicine",
              journal: "BMJ Open Sport & Exercise Medicine, May 2023",
              authors: "Nash Anderson, Diana Robinson, Evert Verhagen, Daniel Belavy, et al.",
              link: "https://www.researchgate.net/publication/370680601_Under-representation_of_women_is_alive_and_well_in_sport_and_exercise_medicine_what_it_looks_like_and_what_we_can_do_about_it"
            },
            {
              title: "AI did not write this manuscript, or did it? Can we trick the AI text detector into generated texts?",
              journal: "BMJ Open Sport & Exercise Medicine, February 2023",
              authors: "Nash Anderson, Daniel Belavy, Stephen M Perle, Aamir Raoof Memon, et al.",
              link: "https://www.researchgate.net/publication/368581864_AI_did_not_write_this_manuscript_or_did_it_Can_we_trick_the_AI_text_detector_into_generated_texts_The_potential_future_of_ChatGPT_and_AI_in_Sports_Exercise_Medicine_manuscript_generation"
            }
          ]
        },
        {
          year: "2022-2016 (Highlights)",
          items: [
            {
              title: "Whose sport is it anyway? Sport taxonomy in manuscripts",
              journal: "BMJ Open Sport & Exercise Medicine, December 2021",
              authors: "Nash Anderson, Reidar P Lystad.",
              link: "https://www.researchgate.net/publication/357078298_Whose_sport_is_it_anyway_Sport_taxonomy_in_manuscripts_some_clarification_required"
            },
            {
              title: "Seven red flags for internships and work experience in top professional sport",
              journal: "British Journal of Sports Medicine, May 2020",
              authors: "Nash Anderson, Bradley Close, Kirsty Easdale.",
              link: "https://www.researchgate.net/publication/341720365_Seven_red_flags_for_internships_and_work_experience_in_top_professional_sport"
            },
            {
              title: "HHITT for concussion evaluation and management",
              journal: "British Journal of Sports Medicine, October 2017",
              authors: "Nash Anderson, Reidar P Lystad.",
              link: "https://www.researchgate.net/publication/305630208_HHITT_for_concussion_evaluation_and_management"
            },
            {
              title: "Pokémon Go: Mobile app user guides",
              journal: "British Journal of Sports Medicine, August 2016",
              authors: "Nash Anderson, James Steele, Lise-Ann O'Neill, Lesley A Harden.",
              link: "https://www.researchgate.net/publication/306301967_Pokemon_Go_Mobile_app_user_guides"
            }
          ]
        }
      ]
    },
    { 
      slug: "javier-palma",
      name: "Dr Javier Palma", 
      role: "Chiropractor", 
      qualifications: "B.A (Behav.Sc); B.App.Sc (Comp.Med); M.Clin.Chiro",
      specialities: ["Neck pain", "Back pain", "Headaches"],
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:800/h:1000/q:mauto/dpr:1.5/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2022/12/PXL_20221216_022540015.PORTRAIT2.jpg",
      bio: [
        "Javier is one of our talented chiropractors with multiple qualifications including a Bachelor of Arts (Behavioural Science), a Bachelor of Applied Science (Complementary Medicine), and a Masters in Clinical Chiropractic.",
        "Javier has worked with our practice for many years and has developed an outstanding relationship with our local GPs. He works closely with them to provide regular communication and quality care for his patients, ensuring a collaborative approach to health management.",
        "His special interests include the management of neck pain, back pain, and headaches. Javier is also an active member of the Australian Chiropractic Association (ACT Branch), staying connected with the latest professional standards and community developments.",
        "To book an appointment with Javier exclusively, you can use our secure online portal or call the practice directly."
      ]
    },
    { 
      slug: "monica-moreno",
      name: "Monica Moreno", 
      role: "Massage therapist", 
      qualifications: "Bowen Therapy (Cert); Oncology Massage Specialist; Member AMT & BTFA",
      specialities: ["Bowen therapy", "Oncology massage", "Lymphatic drainage"],
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:800/h:1000/q:mauto/dpr:1.5/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2025/11/FB_IMG_17422622740982-1.jpg",
      bio: [
        "With over 15 years of experience in the massage industry, Monica brings a wealth of knowledge and a strong commitment to holistic wellness to every session. Her training has taken place both in Australia and overseas, enabling her to integrate a range of therapeutic approaches for personalised and effective care.",
        "Monica specialises in Oncology Massage and was part of the pioneering team that introduced this modality to Spain and Argentina. Her contributions included training therapists and developing future educators, supporting the safe and skilled growth of Oncology Massage in those regions.",
        "Alongside her work in Oncology Massage, Monica holds a certificate in Bowen Therapy—a gentle and precise technique that she finds particularly valuable in addressing a wide variety of musculoskeletal and functional conditions.",
        "She is a member of the Association of Massage Therapists (AMT) and the Bowen Therapy Federation of Australia (BTFA), and remains committed to ongoing learning and maintaining high professional standards.",
        "Whether clients are seeking relaxation, support during or after medical treatment, or targeted therapeutic care, Monica provides thoughtful, compassionate treatment tailored to individual needs."
      ]
    },
    { 
      slug: "jennifer-cummins",
      name: "Jennifer Cummins", 
      role: "Massage therapist & Exercise Physiologist", 
      qualifications: "B.Hlth.Sc (Comp.Med); M.Clin.Ex.Phys (Rehab); Dip.Fitness; Dip.Rem.Mass",
      specialities: ["Musculoskeletal Rehab", "Neurological Conditions", "Remedial Massage"],
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:800/h:1000/q:mauto/dpr:1.5/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2022/04/jen-1.jpg",
      bio: [
        "“You’re a jigsaw puzzle that has fallen apart. We need to first work out why you’ve fallen apart and secondly, we need to work out how we are going to put you back together” – Jennifer Cummins",
        "Jennifer from a young age always wanted to be a physiotherapist. She moved to Canberra from a small rural town in NSW to begin her health and fitness career, initially studying a Diploma of Fitness before completing her Diploma of Remedial Massage at CIT.",
        "During her studies, she discovered a profound passion for remedial massage therapy that reshaped her career path. With 18 years of experience as a remedial massage therapist, she brings a wealth of knowledge and experience to our team.",
        "Jen has furthered her knowledge and understanding of body mechanics with the successful completion of a Bachelor of Health Science (Complementary Medicine) and a Masters of Clinical Exercise Physiology (Rehabilitation). She has a keen interest in musculoskeletal injuries and neurological conditions.",
        "Outside of the clinic, you’ll find Jennifer running the trails or a half marathon, bike riding, or bushwalking with her family and dog."
      ]
    },
    { 
      slug: "marie-sjostrom",
      name: "Marie Sjöström", 
      role: "Massage therapist", 
      qualifications: "Diploma Remedial Massage",
      specialities: ["Remedial massage", "Lymphatic drainage", "Dry needling"],
      img: "https://mlqblpajbgqj.i.optimole.com/cb:-hzJ.4ecd8/w:800/h:1000/q:mauto/dpr:1.5/g:sm/f:best/ig:avif/https://tuggeranongchiromassage.com.au/wp-content/uploads/2022/10/IMG_9706-1.jpg",
      bio: [
        "Marie Sjöström is an experienced massage therapist at Tuggeranong Therapeutic Massage and Tuggeranong Chiropractic Centre, offering remedial massage, lymphatic massage and dry needling.",
        "Marie has a naturally warm, caring and friendly personality, and she enjoys creating a relaxed environment where people feel comfortable and listened to. She understands that everyone comes to massage with different needs, preferences and goals, so she takes a flexible and individual approach to every treatment.",
        "Whether someone is looking for help with muscular tension and soreness, support with recovery, lymphatic massage, or simply a relaxing treatment, Marie adapts her techniques, pressure and treatment style to suit the person in front of her.",
        "Marie enjoys getting to know her patients and helping them feel at ease throughout their appointment. Her thoughtful and adaptable approach makes her a valued part of the massage team at Tuggeranong Chiropractic Centre."
      ]
    }
  ],
  faqs: [
    { 
      q: "What should I wear to my appointment?", 
      a: "We recommend wearing loose, comfortable clothing. For chiropractic assessments, flexible attire like gym wear or loose trousers is ideal to facilitate movement testing." 
    },
    { 
      q: "Do I need a referral from a GP?", 
      a: "No, private patients do not require a referral. However, a GP referral is necessary for DVA, WorkCover, or Chronic Disease Management (CDM) plans. It is our honour to care for veterans; please let us know in advance if you have a DVA referral, specialist reports, or are visiting following a workplace or car accident so we can prepare the necessary documentation for your visit." 
    },
    { 
      q: "How long is the initial consultation?", 
      a: "Your first visit for chiropractic care typically takes between 45 minutes and 1 hour. This ensures we have enough time for a thorough assessment and to discuss your history." 
    },
    { 
      q: "Can I claim my health fund rebate on the spot?", 
      a: "Yes, we provide HICAPS facilities for immediate private health fund claiming at the time of your appointment." 
    }
  ]
};

export const servicesData = {
  'back-pain': {
    title: 'Chiropractic care for back pain',
    seoTitle: 'Chiropractic Care for Back Pain | Tuggeranong Chiro',
    metaDescription: 'Evidence-informed chiropractic care for back pain in Tuggeranong. Assessment, manual therapy and exercise for stiffness, restricted movement and recovery.',
    type: 'treatment',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/635654608a574a2eefbd5e8f5d2743ba.jpg',
    description: "Back pain can make everyday activities difficult—from getting out of bed and sitting at work to lifting, exercising or looking after your family.\n\nAt Tuggeranong Chiropractic Centre, we take the time to understand your back pain, how it is affecting you and what you want to return to doing. Your chiropractor will assess your movement and develop an individual care plan that may combine hands-on chiropractic treatment, practical advice and exercise.\n\nOur Chiropractors bring over 45 years of clinical experience working with people experiencing back pain and other musculoskeletal concerns.",
    benefits: ['Clinical assessment', 'Personalised exercise', 'Evidence-informed care'],
    detailedSections: [
      {
        title: "Can chiropractic care help with back pain?",
        content: "Chiropractic care can be a useful conservative treatment option for many people with non-specific low back pain.\n\nSpinal manipulative therapy is included as an option in major evidence-based guidelines, generally as part of a broader approach that may also involve education, exercise and support to remain active.[1–4] Research suggests spinal manipulation can provide outcomes broadly comparable with other guideline-recommended treatments for chronic low back pain.[3]\n\nNot everyone needs the same treatment. Your care will reflect your symptoms, examination findings, preferences and response to treatment."
      },
      {
        title: "Back pain presentations we commonly assess",
        content: "People visit our chiropractors for concerns such as:",
        items: [
          "New or recurrent lower-back pain",
          "Back stiffness or restricted movement",
          "Pain associated with sitting, standing or sustained positions",
          "Discomfort following lifting, gardening or physical work",
          "Back pain after increasing exercise or training",
          "Pain affecting sleep or everyday activity",
          "Buttock, hip or referred leg discomfort",
          "Sciatica or other nerve-related symptoms",
          "Persistent back pain that has not fully settled"
        ],
        footer: "These symptoms can arise for different reasons. Your chiropractor will assess your presentation before recommending care."
      },
      {
        title: "How may chiropractic treatment help?",
        content: "Chiropractic care aims to help you move more comfortably, manage your symptoms and return to the activities that matter to you.\n\nDepending on your presentation, care may include:",
        items: [
          "**Chiropractic adjustments.** Controlled manual techniques applied to appropriate areas of the spine when suitable and with your consent.",
          "**Joint mobilisation.** Gentler, repeated movements used to improve comfort and movement.",
          "**Soft-tissue treatment.** Hands-on care directed towards muscles and other soft tissues.",
          "**Exercise and rehabilitation.** Individual exercises to develop mobility, strength, endurance or confidence with movement.",
          "**Activity advice.** Practical ways to manage work, lifting, exercise and temporarily aggravating activities.",
          "**Self-management strategies.** Steps you can take between appointments to support progress and remain active."
        ],
        footer: "For some people, hands-on treatment can provide a useful window of reduced pain or improved movement. This can make it easier to begin exercising and gradually return to normal activities."
      },
      {
        title: "What happens at your first appointment?",
        content: "Your chiropractor will ask about your back pain, general health, previous injuries, daily activities and what you would like help achieving.",
        items: [
          "Lower-back and hip movement assessment.",
          "Identifying areas of tenderness, stiffness or restricted movement.",
          "Muscle strength and control testing.",
          "Functional movements such as bending or squatting.",
          "Reflexes, strength and sensation testing when leg or nerve symptoms are present."
        ],
        footer: "Your chiropractor will explain the likely nature of your symptoms and discuss suitable options. If chiropractic care is appropriate and you are comfortable proceeding, treatment may be provided at your first appointment."
      },
      {
        title: "Referrals, Veterans & Accidents",
        type: "info",
        content: "As a clinic, we're all proud to look after veterans—it's our honour. To help us provide the most effective care, we ask that you let us know in advance if:",
        items: [
          "You have been referred by your GP or a specialist.",
          "You have clinical reports or a DVA referral to bring in.",
          "You are visiting following a workplace or car accident.",
          "You have specific insurance or rehabilitation requirements."
        ],
        footer: "Providing this information in advance makes it possible for us to help prepare the necessary documentation before your visit."
      },
      {
        title: "A practical and evidence-informed approach",
        content: "Most low back pain does not have one simple structural cause. That does not mean the pain is imaginary or that nothing can be done.\n\nEvidence-based management commonly combines education, remaining active, exercise and selected physical treatments such as spinal manipulation.[1–5] Chiropractic care can bring these elements together in a plan tailored to your symptoms, goals and lifestyle.",
        items: [
          "Moving more comfortably",
          "Returning to work or exercise",
          "Improving sleep or activity tolerance",
          "Managing flare-ups more confidently",
          "Reducing the impact of pain on everyday life"
        ],
        footer: "Results vary, and no particular outcome can be guaranteed. If you are not making useful progress, your chiropractor will reconsider the plan and discuss other options."
      },
      {
        title: "Will I need an X-ray?",
        content: "Most people with uncomplicated back pain do not require an X-ray before beginning care.\n\nTuggeranong Chiropractic Centre has on-site X-ray facilities when imaging is clinically indicated and likely to assist diagnosis or management. This may include particular injuries, relevant health concerns or examination findings that require further investigation.\n\nIf MRI, CT or another investigation would be more appropriate, your chiropractor can discuss the relevant referral pathway. Imaging results are always considered alongside your symptoms and physical examination."
      },
      {
        title: "Frequently asked questions",
        items: [
          "**Does my back have to be adjusted?** No. Chiropractic adjustments are one option. Care can also include mobilisation, soft-tissue techniques, exercise, advice or referral. Choices are discussed before care begins.",
          "**Is my back “out of alignment”?** Back pain is usually more complex than a bone being simply “out”. Factors like joints, muscles, nerves, load, sleep, and general health all contribute. We do not claim the spine must be repeatedly “put back into place”.",
          "**How many appointments will I need?** There is no standard schedule. Recommendations depend on your presentation, goals and response to care. Progress is reviewed regularly.",
          "**Should I remain active with back pain?** For most uncomplicated back pain, continuing comfortable activity is generally preferable to prolonged bed rest.[1] Your chiropractor can help you decide what is reasonable.",
          "**Can my chiropractor work with my GP?** Yes. With your consent, we communicate with your GP or other practitioners when coordinated care or further investigation would be helpful."
        ]
      },
      {
        title: "Emergency Care Advice",
        type: "urgent",
        content: "Seek urgent medical attention for back pain accompanied by new loss of bladder or bowel control, numbness around the groin or buttocks, rapidly worsening leg weakness, significant trauma or feeling seriously unwell. Call 000 in an emergency.",
        footer: "This information is general and does not replace individual healthcare advice."
      }
    ],
    pricing: { 'Initial consultation': "$195.00", 'Subsequent visit': "$105.00" },
    note: "Initial consultations take between 45 minutes and 1 hour. HICAPS available for immediate health fund rebates.",
    references: [
      "Australian Commission on Safety and Quality in Health Care. Low Back Pain Clinical Care Standard. 2022.",
      "World Health Organization. WHO guideline for management of chronic primary low back pain. 2023.",
      "Rubinstein SM, et al. Spinal manipulative therapy for chronic low back pain: systematic review. BMJ. 2019.",
      "George SZ, et al. Interventions for the management of acute and chronic low back pain: revision 2021. JOSPT. 2021.",
      "Hayden JA, et al. Exercise therapy for chronic low back pain. Cochrane Database Syst Rev. 2021."
    ]
  },
  'neck-pain': {
    title: 'Chiropractic care for neck pain',
    seoTitle: 'Chiropractic Care for Neck Pain | Tuggeranong Chiro',
    metaDescription: 'Evidence-informed chiropractic care for neck pain in Tuggeranong. Assessment, manual therapy and exercise for stiffness, aches and discomfort.',
    type: 'treatment',
    heroImage: 'https://d1zviajkun9gxg.cloudfront.net/user/prod/2023/08/01/deal-6f1cc706-a30a-4a03-a5d2-fc1b4fcf0326.jpeg',
    description: "Neck pain can make everyday activities uncomfortable—from turning your head while driving to working, exercising or getting a good night’s sleep.\n\nAt Tuggeranong Chiropractic Centre, our chiropractors assess how your neck is moving, discuss what may be contributing to your symptoms and develop a care plan around your needs. Depending on your presentation, care may combine hands-on treatment, practical advice and exercise.",
    benefits: ['Clinical assessment', 'Hands-on treatment', 'Exercise & advice'],
    detailedSections: [
      {
        title: "Can chiropractic care help with neck pain?",
        content: "Chiropractors are registered health practitioners trained to assess and manage musculoskeletal conditions, including many common forms of neck pain.\n\nFor some adults with non-specific neck pain, combining manual therapy with exercise may reduce pain and disability, particularly in the short term. Exercise can also help improve movement, strength and confidence using the neck.[1–4]\n\nChiropractic care is not the same for everyone. Your treatment will depend on your symptoms, examination findings, preferences and response to care."
      },
      {
        title: "Referrals, Veterans & Accidents",
        type: "info",
        content: "As a clinic, we're all proud to look after veterans—it's our honour. To help us provide the most effective care, we ask that you let us know in advance if:",
        items: [
          "You have been referred by your GP or a specialist.",
          "You have clinical reports or a DVA referral to bring in.",
          "You are visiting following a workplace or car accident.",
          "You have specific insurance or rehabilitation requirements."
        ],
        footer: "Providing this information in advance makes it possible for us to help prepare the necessary documentation before your visit."
      },
      {
        title: "Neck pain presentations we commonly assess",
        content: "People visit our chiropractors for concerns such as:",
        items: [
          "A sore, stiff or difficult-to-move neck",
          "Recurrent neck aches",
          "Discomfort associated with desk work or sustained positions",
          "Pain after a change in exercise, workload or activity",
          "Difficulty turning the head while driving",
          "Neck and upper-back muscle tension",
          "Headaches that may be associated with the neck",
          "Neck pain accompanied by shoulder or arm symptoms"
        ],
        footer: "These symptoms can have different causes. Your chiropractor will assess your presentation before recommending care."
      },
      {
        title: "What might chiropractic treatment include?",
        content: "Your care may include a combination of:",
        items: [
          "**Joint mobilisation.** Gentle, repeated movement applied to an appropriate area of the neck or upper back.",
          "**Chiropractic adjustments.** Controlled manual techniques used when suitable and with your consent.",
          "**Soft-tissue treatment.** Hands-on care directed towards muscles and other soft tissues.",
          "**Exercise.** Individual exercises to improve movement, strength, endurance or control.",
          "**Practical advice.** Guidance about activity, work, sleep, exercise and managing aggravating tasks.",
          "**Self-management strategies.** Simple ways to remain active and build confidence between appointments."
        ],
        footer: "An adjustment is only one treatment option. You do not have to have your neck manipulated, and your chiropractor can discuss alternative approaches."
      },
      {
        title: "What happens at the first appointment?",
        content: "Your chiropractor will begin by asking about your symptoms, health history, previous injuries, daily activities and what you would like to improve.",
        items: [
          "Neck and upper-back movement assessment.",
          "Identifying areas of tenderness or stiffness.",
          "Muscle strength and control testing.",
          "Shoulder movement review.",
          "Reflexes, strength and sensation testing when relevant."
        ],
        footer: "Your chiropractor will then explain the likely nature of your neck pain and discuss suitable options. If chiropractic care is appropriate and you are comfortable proceeding, treatment may be provided at the first appointment."
      },
      {
        title: "An individual and evidence-informed approach",
        content: "Research does not identify one technique that is best for every person with neck pain. Current evidence supports matching care to the individual and commonly combining manual treatment with exercise and advice.[1–4]\n\nWe monitor your progress and adjust the plan according to changes in pain, movement and everyday activity. Outcomes vary, and no particular result can be guaranteed."
      },
      {
        title: "Will I need an X-ray?",
        content: "Most people with uncomplicated neck pain do not require an X-ray before beginning care.\n\nTuggeranong Chiropractic Centre has on-site X-ray facilities when imaging is clinically indicated and likely to assist diagnosis or management. If another investigation, such as MRI or CT, would be more appropriate, your chiropractor can discuss the relevant referral options."
      },
      {
        title: "Frequently asked questions",
        items: [
          "**Does my neck have to be “cracked”?** No. Some patients choose adjustments, while others prefer mobilisation, soft-tissue treatment, exercise or a combination. Choices are discussed with you before care begins.",
          "**Is the clicking sound important?** A clicking sound can occur when pressure changes within a joint. It is not required for treatment to be useful and does not show that a joint has been “put back into place”.",
          "**How many appointments will I need?** There is no standard schedule. Recommendations depend on your symptoms, goals and response to care. Progress should be reviewed regularly.",
          "**Can my chiropractor work with my GP?** Yes. With your consent, we communicate with your GP or other practitioners when coordinated care or further investigation would be helpful."
        ]
      },
      {
        title: "Emergency Care Advice",
        type: "urgent",
        content: "Seek urgent medical attention for neck pain following significant trauma or neck pain accompanied by sudden weakness, facial drooping, difficulty speaking, severe unsteadiness or other rapidly developing neurological symptoms. Call 000 in an emergency.",
        footer: "This information is general and does not replace individual healthcare advice."
      }
    ],
    pricing: { 'Initial consultation': "$195.00", 'Subsequent visit': "$105.00" },
    note: "Initial consultations take between 45 minutes and 1 hour. HICAPS available for immediate health fund rebates.",
    references: [
      "Reynolds B, et al. Manual physical therapy for neck disorders: an umbrella review. J Man Manip Ther. 2025.",
      "Minnucci S, et al. Benefits and harms of spinal manipulative therapy for persistent nonspecific neck pain. JOSPT. 2023.",
      "Jones LB, et al. The influence of exercise on pain and quality of life in office workers with chronic neck pain. Appl Ergon. 2024.",
      "Blanpied PR, et al. Neck pain: revision 2017. J Orthop Sports Phys Ther. 2017.",
      "AHPRA. Acceptable evidence in health advertising guidelines."
    ]
  },
  'headaches-migraines': {
    title: 'Headaches and migraines',
    seoTitle: 'Chiropractic Care for Headaches & Migraines | Tuggeranong Chiro',
    metaDescription: 'Chiropractic care for headaches and migraines in Tuggeranong. Assessment of neck-related headache patterns, cervicogenic headaches, and migraine-associated neck pain.',
    type: 'treatment',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/acc11496f236d38f2abdc0dde48ed310.jpg',
    description: "Headaches can interfere with concentration, work, sleep, exercise and time with family. They are also commonly experienced alongside neck pain, stiffness, muscle tension or restricted movement.\n\nAt Tuggeranong Chiropractic Centre, our chiropractors assess your headache pattern and examine whether joints, muscles or movement in the neck may be contributing to your symptoms. Where appropriate, care may include chiropractic treatment, soft-tissue techniques, exercise and practical advice.",
    benefits: ['Clinical assessment', 'Manual therapy', 'Exercise & advice'],
    detailedSections: [
      {
        title: "Can chiropractic care help with headaches?",
        content: "Chiographic care may help some people with headaches that are related to the neck, particularly cervicogenic headaches.\n\nResearch suggests that spinal manipulation, mobilisation and exercise may help reduce the frequency, intensity and impact of cervicogenic headaches for some patients.[1–4] Manual therapy and exercise may also be useful for some people with tension-type headaches, especially when neck pain, stiffness or muscle tenderness is present.[4,5]\n\nYour chiropractor will assess your individual presentation and recommend care based on your symptoms, preferences and response to treatment."
      },
      {
        title: "Headache concerns we commonly assess",
        content: "People visit our chiropractors for:",
        items: [
          "Headaches that seem to begin in the neck or base of the skull",
          "Headaches accompanied by neck pain or stiffness",
          "Pain that travels from the back of the head towards the forehead or eye",
          "Headaches aggravated by neck movement or sustained positions",
          "Headaches associated with desk work, driving or physical workload",
          "Tension-type headaches with neck and shoulder discomfort",
          "Recurrent headaches associated with restricted neck movement",
          "Migraine accompanied by neck pain, stiffness or muscle tension",
          "Headaches following a previous neck injury"
        ],
        footer: "Different headache types can overlap. An assessment helps determine whether there is a musculoskeletal component that may benefit from chiropractic care."
      },
      {
        title: "What is a cervicogenic headache?",
        content: "A cervicogenic headache is a recognised headache disorder in which pain is attributed to a problem involving the neck.[1]\n\nIt may involve:",
        items: [
          "Headache and neck pain occurring together",
          "Reduced or uncomfortable neck movement",
          "Pain beginning near the neck or base of the skull",
          "Symptoms that travel towards the forehead, temple or eye",
          "Headache aggravated by particular movements or positions",
          "Tender or restricted areas in the upper neck",
          "A headache pattern that is often, although not always, one-sided"
        ],
        footer: "Cervicogenic headaches are particularly relevant to chiropractic care because treatment can be directed towards the associated neck movement, joint and muscular findings."
      },
      {
        title: "How may chiropractic treatment help?",
        content: "The aim of chiropractic care is to improve the musculoskeletal factors that may be contributing to your headache pattern.\n\nDepending on your assessment, care may include:",
        items: [
          "**Chiropractic adjustments.** Controlled manual techniques applied to an appropriate area of the neck or upper back, with your consent.",
          "**Joint mobilisation.** Gentler movements used to improve comfort and neck mobility.",
          "**Soft-tissue treatment.** Hands-on care directed towards tight or tender muscles.",
          "**Neck and shoulder exercises.** Individual exercises to improve mobility, strength, endurance and movement control.",
          "**Work and activity advice.** Practical strategies for desk work, driving, exercise and other aggravating activities.",
          "**Headache self-management.** Advice about movement, sleep, activity and monitoring headache patterns."
        ],
        footer: "An adjustment is only one option. Your chiropractor can adapt treatment if you prefer mobilisation, soft-tissue techniques, exercise or a gentler approach."
      },
      {
        title: "What happens at your first appointment?",
        content: "Your chiropractor will ask about where your headache begins, how often it occurs, and how long it lasts. They will also review your history and perform relevant testing.",
        items: [
          "Neck and upper-back movement assessment.",
          "Muscle and joint function evaluation.",
          "Postural analysis.",
          "Relevant neurological testing.",
          "Identification of activities or positions that aggravate symptoms."
        ],
        footer: "We will explain our findings and discuss whether chiropractic care is suitable. If you are comfortable proceeding, treatment may be provided at your first appointment."
      },
      {
        title: "Chiropractic care and migraine-associated neck pain",
        content: "Migraine is a complex neurological condition, but many people with migraine also experience neck pain, stiffness or restricted movement.\n\nChiropractic care may be used alongside your usual migraine management to address these associated musculoskeletal symptoms. This may be particularly relevant when neck discomfort continues between attacks or certain positions aggravate symptoms.",
        footer: "Your chiropractor can work with your GP or other healthcare practitioners when a combined approach is appropriate."
      },
      {
        title: "A personalised approach to headache care",
        content: "There is no single treatment that suits every headache. Your care will reflect your type of headache, examination findings, and treatment preferences.",
        items: [
          "Individualised management plans",
          "Regular review of headache frequency and intensity",
          "Integration with work and lifestyle requirements",
          "Use of headache diaries to recognise patterns"
        ]
      },
      {
        title: "Frequently asked questions",
        items: [
          "**Can a chiropractor help with migraines?** Yes, for people who also experience neck pain, stiffness, or restricted movement alongside their migraine.",
          "**What is a cervicogenic migraine?** It's a term sometimes used to describe migraine accompanied by neck pain, though not a formal diagnosis.",
          "**Does neck pain mean my headache comes from my neck?** Not always, but reproduction of familiar symptoms during examination may suggest a contribution.",
          "**Does my neck have to be adjusted?** No. Choices include gentler mobilisation, soft-tissue techniques, and exercise.",
          "**Can massage help with headaches?** Yes, especially when accompanied by neck, shoulder, or scalp muscle tension."
        ]
      },
      {
        title: "Emergency Care Advice",
        type: "urgent",
        content: "Seek urgent medical attention (Call 000) for a sudden, extremely severe headache or a headache accompanied by new weakness, facial drooping, difficulty speaking, confusion, seizure, or fainting.",
        footer: "Prompt medical assessment is also appropriate for a substantially changed headache or severe headache following head trauma."
      }
    ],
    pricing: { 'Initial consultation': "$195.00", 'Subsequent visit': "$105.00" },
    note: "Initial consultations take between 45 minutes and 1 hour. HICAPS available for immediate health fund rebates.",
    references: [
      "Headache Classification Committee of the International Headache Society. Cervicogenic headache. ICHD-3.",
      "Bini P, et al. Effectiveness of manual and exercise therapy on headache intensity. Chiropr Man Therap. 2022.",
      "Fernandez M, et al. Spinal manipulation for the management of cervicogenic headache. Eur J Pain. 2020.",
      "Côté P, et al. Non-pharmacological management of persistent headaches associated with neck pain. Eur J Pain. 2019.",
      "Kamonseki DH, et al. Effectiveness of manual therapy in patients with tension-type headache. Disabil Rehabil. 2022."
    ]
  },
  'massage': {
    title: 'Remedial massage',
    type: 'treatment',
    heroImage: 'https://d1zviajkun9gxg.cloudfront.net/user/prod/2023/05/17/deal-55c74ee6-4653-4169-a843-a85f836a12a0.jpeg',
    description: 'Qualified remedial massage therapy focusing on muscle recovery and tension management. Our experienced therapists provide tailored sessions based on your physical needs.',
    benefits: ['Remedial & sports techniques', 'Qualified clinical therapists', 'HICAPS rebates available'],
    pricing: { '0.5 hour session': "$100.00", '1 hour session': "$145.00", '1.5 hour session': "$185.00" },
    note: "Includes remedial, therapeutic, and Bowen therapy. Concession rates available."
  },
  'lymphatic-drainage': {
    title: 'Lymphatic drainage',
    type: 'treatment',
    heroImage: 'https://d1zviajkun9gxg.cloudfront.net/user/prod/2023/05/17/deal-8100a022-c884-4c8a-887a-574CD0011FE6.jpeg',
    description: 'A gentle clinical technique utilised to support fluid management and reduce localised swelling. Often utilised in post-surgical recovery or for specific inflammatory conditions.',
    benefits: ['Support for fluid management', 'Gentle inflammatory support', 'Post-surgical recovery aid'],
    pricing: { '0.5 hour session': "$100.00", '1 hour session': "$145.00", '1.5 hour session': "$185.00" },
    note: "Specialised gentle technique. Please discuss your specific medical history with our therapist."
  },
  'myofascial-dry-needling': {
    title: 'Dry needling',
    type: 'treatment',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/d37124af05a9e3589345bed2a4a16401eb631d4b4b631600ea02a5d56f4ed61b615c9698b7774c9e033954f7bfaf1e4f/images/aW1hZ2UvanBlZw==/7e7cd1ff7ca5ea7c343ba1cc9bec1e46.jpg',
    description: 'Dry needling involves the use of fine, sterile needles to help manage muscle tension and stiffness. It is used alongside other treatments to help you move more comfortably.',
    benefits: ['Help with muscle tension', 'Support for easier movement', 'Manage areas of stiffness'],
    pricing: { 'Standard Consultation': "Varies by practitioner", 'Dry Needling': "No additional fee" },
    note: "Dry needling is provided as part of your chiropractic or remedial massage visit at no extra cost when recommended by your practitioner."
  },
  'x-rays': {
    title: 'Diagnostic X-rays',
    type: 'procedure',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/26362358d32a79c2f46cab2caf4fb109.jpg',
    description: 'Tuggeranong Chiropractic Centre has on-site digital X-ray facilities, allowing clinically indicated spinal X-rays to be taken conveniently at the clinic.',
    benefits: ['Professional clinical report', 'On-site diagnostic imaging', 'Assists in management planning'],
    detailedSections: [
      {
        title: "On-Site Digital X-rays",
        content: "Tuggeranong Chiropractic Centre has on-site digital X-ray facilities, allowing clinically indicated spinal X-rays to be taken conveniently at the clinic without needing to visit a separate imaging provider."
      },
      {
        title: "What Is an X-ray?",
        content: "An X-ray uses a small amount of ionising radiation to create images of structures inside the body. Dense structures such as bones appear clearly, making X-rays useful for examining the vertebrae and joints of the spine.",
        footer: "X-rays primarily show bones and joint spaces. They do not provide detailed images of soft tissues such as muscles, spinal discs, nerves or ligaments. If these structures need further investigation, another form of imaging or medical assessment may be more appropriate."
      },
      {
        title: "Why Might an X-ray Be Recommended?",
        content: "X-rays are not required for every patient and are only considered when the findings may assist clinical decision-making. Depending on your history and examination, your chiropractor may recommend an X-ray to:",
        items: [
          "investigate symptoms following an injury or significant trauma;",
          "assess a suspected fracture or other bony change;",
          "examine spinal structure, alignment or joint changes;",
          "identify findings that may affect the suitability of particular treatment approaches;",
          "investigate persistent or unusual symptoms where imaging is clinically indicated; or",
          "determine whether referral for further assessment or different imaging may be appropriate."
        ],
        footer: "Your chiropractor will consider your symptoms, health history, examination findings and relevant imaging guidelines before recommending an X-ray. The reasons for imaging, expected costs and relevant safety considerations will be discussed with you before proceeding."
      },
      {
        title: "Convenience & Interpretation",
        content: "Having X-ray facilities on site can make the assessment process more convenient and allows the images to be considered as part of your overall clinical assessment. An X-ray does not provide a complete diagnosis by itself and will be interpreted alongside your history and physical examination.",
        footer: "Please tell your practitioner before imaging if you are or may be pregnant."
      }
    ],
    pricing: { 'X-ray (per region)': "From $150.00" },
    note: "All X-ray procedures include a comprehensive clinical report by a qualified practitioner."
  },
  'custom-orthotics': {
    title: 'Custom orthotics & foot scans',
    type: 'treatment',
    heroImage: 'https://media-manager-c.questera.ai/greta-media/388b1ab148d242655c048137613aa2bb6657adf5ebb8c647cad863997bd04ba744fbeb8b80e3364ef13bb85060475943/images/aW1hZ2UvanBlZw==/28a8d4dd33c9610473f13495df827e3d.jpg',
    description: 'We use digital foot scanning to check how you walk and stand. If needed, we provide custom shoe inserts (orthotics) to support your feet.',
    benefits: ['Digital foot scan', 'Custom-fitted shoe inserts', 'Detailed gait analysis'],
    detailedSections: [
      {
        title: "Digital Foot and Gait Assessment",
        content: "Our computerised foot and gait assessment uses a pressure-sensitive platform to record how pressure is distributed across your feet while you stand and walk. The scan produces visual information about factors such as weight distribution, foot pressure and the timing of each step."
      },
      {
        title: "How Digital Foot Scanning Works",
        items: [
          "**Pressure mapping:** Records areas of higher and lower pressure beneath the feet.",
          "**Standing and walking assessment:** Provides information about how pressure patterns change during different stages of movement.",
          "**Visual reporting:** Presents the recorded information in an easy-to-understand graphical format."
        ]
      },
      {
        title: "How the Information May Be Used",
        content: "Your practitioner will interpret the scan alongside your symptoms, health history and physical examination. When clinically appropriate, this information may assist with:",
        items: [
          "understanding aspects of your foot function and gait;",
          "discussing footwear and activity considerations;",
          "informing exercise or management recommendations; and",
          "assessing whether custom-made orthotics may be appropriate."
        ],
        footer: "A digital foot scan is one component of a broader clinical assessment. Scan findings do not, by themselves, diagnose a condition or mean that orthotics or treatment are required."
      }
    ],
    pricing: { 'Foot scan (existing patients)': "$0.00", 'Custom orthotics pair': "$595.00" },
    note: "A foot scan is a simple, pain-free check to see if orthotics are right for you."
  }
};

export const legalData = {
  'privacy-policy': {
    title: 'Privacy policy',
    lastUpdated: 'August 2023',
    content: `Privacy policy for CBR Healthcare Ltd. We are committed to protecting your personal and health information in accordance with Australian Privacy Principles.`
  },
  'terms-of-service': {
    title: 'Terms of service',
    lastUpdated: 'August 2023',
    content: `Clinical assessment terms. We provide a thorough initial consultation. If our practitioners determine that our services are not clinically indicated for your condition, appropriate referrals will be provided.`
  }
};